/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { AsyncPipe, NgTemplateOutlet } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { ButtonComponent,
    CodeSnippetComponent, ScrollContainerComponent,
    LinkPanelComponent, ModalComponent, PropertiesTableComponent, PropertiesTableRowComponent, SpinnerComponent, FormPasswordInputComponent, requiredValidator, FormComponent, FormActionsComponent, ModalCloseButtonComponent, FormInputComponent
} from "typedb-cloud-framework";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { SnackbarService } from "../../../../../service/snackbar.service";
import { combineLatest, filter, map, shareReplay } from "rxjs";
import { MatSelectModule } from "@angular/material/select";
import { MatStepperModule } from "@angular/material/stepper";
import { clusterCredentialFilename, ConnectDialogData, copy, parseVersionString, PASSWORD_FILLER } from "../../shared";
import { ClusterLoadingTipsComponent } from "../loading/cluster-loading-tips.component";
import { ClusterStatus } from "../../../../../concept/cluster";

@Component({
    selector: "tp-cluster-http-connect-dialog",
    templateUrl: "./cluster-http-connect-dialog.component.html",
    styleUrls: ["./cluster-http-connect-dialog.component.scss"],
    imports: [
        AsyncPipe, MatTooltipModule, MatButtonModule, MatSelectModule,
        CodeSnippetComponent, ScrollContainerComponent, MatStepperModule,
        MatDialogContent, MatDialogTitle, ModalCloseButtonComponent, ClusterLoadingTipsComponent
    ]
})
export class ClusterHttpConnectDialogComponent {
    serverAddresses$ = combineLatest([this.data.servers$, this.data.cluster$]).pipe(
        filter(([servers, cluster]) => servers.every((server) => !!server.address) && servers.length == cluster.serverCount),
        map(([servers, _]) => servers.map((server) => server.address!)),
        shareReplay(1),
    );
    clusterStatus$ = this.data.cluster$.pipe(map((cluster) => cluster.status));
    ready$ = this.clusterStatus$.pipe(map((status) => status == "running"));

    private loadingStatuses: ClusterStatus[] = ["starting", "resuming"];
    loading$ = this.clusterStatus$.pipe(map((status) => this.loadingStatuses.includes(status)));

    parsedVersion$ = this.data.cluster$.pipe(map(cluster => parseVersionString(cluster.typeDBVersion.version)));
    isTypeDBVersion2$ = this.parsedVersion$.pipe(map(version => version.major == 2));

    docsVersionSpecifier$ = this.isTypeDBVersion2$.pipe(map((isVersion2) => isVersion2 ? "2.x/" : ""));
    driverDocsLink$ = this.docsVersionSpecifier$.pipe(map((specifier) => `https://typedb.com/docs/drivers/${specifier}`));
    httpAPIDocsLink$ = this.driverDocsLink$.pipe(map((driverDocsLink) => `${driverDocsLink}http/api-reference`));

    httpAPICommand$ = this.serverAddresses$.pipe(
        map(addresses => `curl ${addresses[0]}/v1/signin --request POST --json '{"username": "admin", "password": "&lt;${PASSWORD_FILLER}&gt;"}'`)
    );

    constructor(
        private dialogRef: MatDialogRef<ClusterHttpConnectDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConnectDialogData, protected snackbar: SnackbarService,
    ) { }

    close() {
        this.dialogRef.close();
    }

    protected readonly clusterCredentialFilename = clusterCredentialFilename;
    protected readonly copy = copy;
}
